import React from 'react';
import {motion} from 'framer-motion'
import { fadeIn } from '../../constants/variants';
import SubHeading from '../SubHeading/SubHeading';
import './Newsletter.css';

const Newsletter = () => (
  <motion.div
        variants={fadeIn('right')}
        initial='hidden'
        whileInView={'show'}
        viewport={{ once: false, amount: 0.6 }} 
    className="app__newsletter">
    <div className="app__newsletter-heading">
      <SubHeading title="Newsletter" />
      <h1 className="headtext__cormorant">Subscribe To Our Newsletter</h1>
      <p className="p__opensans">And never miss the latest Updates!</p>
    </div>
    <div className="app__newsletter-input flex__center">
      <input type="email" placeholder="Enter your email address" />
      <button type="button" className="custom__button">Subscribe</button>
    </div>
  </motion.div>
);

export default Newsletter;